export default "__VITE_ASSET__D2rmte68__"